// src/redux/slices/paymentSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to simulate payment processing with Stripe or Razorpay.
export const processPayment = createAsyncThunk(
  'payment/processPayment',
  async (paymentMethod, { rejectWithValue }) => {
    try {
      // Simulate API delay for payment processing
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // In a real-world scenario, you'd call your backend/payment API here
      // For simulation, we return dummy order summary data:
      return {
        orderNumber: "#3234557",
        totalAmount: "$39.00",
        estimatedDelivery: "Feb 15, 2025",
      };
    } catch (error) {
      return rejectWithValue("Payment processing failed");
    }
  }
);

const initialState = {
  step: 1, // 1: checkout, 2: confirmation
  selectedPaymentMethod: "stripe", // "stripe" or "razorpay"
  processing: false,
  error: null,
  orderSummary: null,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    // Action to update the selected payment method
    setSelectedPaymentMethod: (state, action) => {
      state.selectedPaymentMethod = action.payload;
    },
    // Action to manually set the current step (if needed)
    setStep: (state, action) => {
      state.step = action.payload;
    },
    // Action to reset payment state (for example, when starting a new transaction)
    resetPayment: (state) => {
      state.step = 1;
      state.selectedPaymentMethod = "stripe";
      state.processing = false;
      state.error = null;
      state.orderSummary = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(processPayment.pending, (state) => {
        state.processing = true;
        state.error = null;
      })
      .addCase(processPayment.fulfilled, (state, action) => {
        state.processing = false;
        state.step = 2; // move to confirmation step
        state.orderSummary = action.payload;
      })
      .addCase(processPayment.rejected, (state, action) => {
        state.processing = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedPaymentMethod, setStep, resetPayment } = paymentSlice.actions;
export default paymentSlice.reducer;
